import { type JSX } from 'react';
import styles from './SkeletonCard.module.css';
import type { SkeletonCardProps } from './SkeletonCard.types';

const SkeletonCard = ({
  width,
  height,
  aspectRatio,
  className = '',
  styleOverride = {},
}: SkeletonCardProps = {}): JSX.Element => {
  const toPx = (value: string | number): string => {
    return typeof value === 'number' ? `${value}px` : value;
  };

  const containerStyle: React.CSSProperties = { ...styleOverride };

  if (width && height) {
    containerStyle.width = toPx(width);
    containerStyle.height = toPx(height);
  } else if (width && aspectRatio) {
    containerStyle.width = toPx(width);
    containerStyle.aspectRatio = aspectRatio;
  } else if (height && aspectRatio) {
    containerStyle.height = toPx(height);
    containerStyle.width = `calc(${containerStyle.height} * ${aspectRatio})`;
  } else if (width) {
    containerStyle.width = toPx(width);
    containerStyle.height = '100%';
  } else if (height) {
    containerStyle.height = toPx(height);
    containerStyle.width = '100%';
  }

  return (
    <div
      className={`${styles.skeletonItem} ${className}`}
      style={containerStyle}
    />
  );
};

export default SkeletonCard;
